import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SendAnalyticsDirective } from './send-analytics.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [SendAnalyticsDirective],
  exports: [SendAnalyticsDirective]
})
export class SendAnalyticsModule {}
